import React from 'react';
import { IconArrowUpRight, IconArrowDownRight, IconMinus } from '@tabler/icons-react';
import styles from './ProjectList.module.scss';
import { formatDelta } from '../ReportMetrics/intelligence';
import { delta as deltaColors, chrome } from '../ReportMetrics/reportTheme';

interface ProjectTrendCellProps {
  /** The tr.project_health_trend value: the change against the 7-day lookback. */
  value?: number;
}

/**
 * The Dashboard's "Trend (7 Tage)" column. A project with no comparable
 * snapshot yet shows a flat dash rather than an implied "no change" - the two
 * mean different things, and the engine distinguishes them.
 */
const ProjectTrendCell: React.FC<ProjectTrendCellProps> = ({ value }) => {
  const { delta, direction } = formatDelta(value);

  const Icon =
    direction === 'up' ? IconArrowUpRight : direction === 'down' ? IconArrowDownRight : IconMinus;

  const color =
    direction === 'up' ? deltaColors.good : direction === 'down' ? deltaColors.bad : chrome.muted;

  return (
    <span className={styles.trendValue} style={{ color }}>
      <Icon size={14} stroke={2.2} />
      {delta}
    </span>
  );
};

export default ProjectTrendCell;
